function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 3.175 3.969"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5Zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4z",
    style: {
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(.26458 0 0 .26458 -1.588 -1.323)"
  }));
};
export default SvgDownload;